export const contentForLevelPanel = [
  {
    title: 'Level 1',
    text: "Если 'Hello world' - ваш максимум? Тогда к нам!",
  },
  {
    title: 'Level 2',
    text: "Знаете кто такой 'I am'. Заходите!",
  },
  {
    title: 'Level 3',
    text: "Можете вот так  легко: 'London is the capital of Great Britain'. Рады видеть!",
  },
  {
    title: 'Level 4',
    text: "'There is, there are'. Знакомы? Вам сюда!",
  },
  {
    title: 'Level 5',
    text: "Умеете так:'Present Perfect Continuous'? Тогда скорее к нам!",
  },
  {
    title: 'Level 6',
    text: 'Вы знаете, кто такой Герундий? Мы ждали вас!',
  },
]
